Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selfBlockquoteReset = void 0;
exports.selfBlockquoteReset = {
  ncss: {
    boxSizing: 'border-box',
    fontFamily: 'text'
  }
};